<template>
    <div class="row mt-1">
        <div class="col-md-10 col-md-offset-1">
            <div class="panel panel-default">
                <div class="panel-heading">
                    <h2 class="panel-title">
                        Choose a hospital
                    </h2>
                </div>
                <table class="table table-default table-striped" id="hospitalsTable" name="hospitalsTable">
                    <thead>
                        <tr>
                            <th>CAHID</th>
                            <th>Hospital Name</th>
                            <th>City</th>
                            <th>Action</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(hospital, index) in arrhospitals">
                        
                            <td>{{  hospital.cahid }}</td>
                            <td>{{  hospital.name }}</td>
                            <td>{{  hospital.cahcity }}</td>
                            <td><button class="btn btn-sm btn-default"  @click="setHospitalId(hospital.cahid, hospital.name)">View Dashboard</button></td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
</template>

<script type="module">

</script>

<script setup>


import { watch, toRaw, nextTick } from 'vue'
import { storeToRefs } from 'pinia'
import { useVisualizationsStore } from '../../stores/vis_store'


const {  fetchHospitals, setHospitalId } = useVisualizationsStore()
const { selectedIndicatorId , chartType, arrindicators, arrhospitals, loading} = storeToRefs(useVisualizationsStore())
var store = useVisualizationsStore()

fetchHospitals();
var arrHospitals = toRaw(arrhospitals.value)
//console.log(arrHospitals);

watch(arrhospitals, async () => {
    var arrHospitals = toRaw(arrhospitals.value)
    if (  arrHospitals !== undefined && arrHospitals.length > 0 ) {
        //window.alert(arrHospitals.length)
        nextTick(() => {
            $('#hospitalsTable').DataTable();
        });

    }
  
})


</script>